import { EnvConfiguration } from "./AppConfiguration";

export const production: EnvConfiguration = {
    api: "https://app-idsplatform-api-prod.azurewebsites.net/",
    assets: "https://stidsplatformprod.blob.core.windows.net/assets/",
    canonical: "https://www.bimids.eu",
    auth: {
        audience: "https://app-idsplatform-api-prod.azurewebsites.net/",
        domain: "bimids.eu.auth0.com",
        clientId: "8niBsC1pl8qzrcCFRoyQm3aVNXZECLzH",
        logoutTo: `https://${window.location.hostname}`,
        scope: "openid email profile offline_access read:current_user update:current_user_metadata admin:access",
    },
    algolia: {
        appId: "OKRNWEA4OH",
        apiKey: "4527e3ddd4c483ae933b1e9381495de2",
        index: "bimids-prd",
    },
    bimq: {
        clientId: "Buildwise",
        redirectUri: `https://${window.location.hostname}/bimq-auth-callback`,
        authorizeEndpoint: "https://server.bim-q.de/oauth/authorize",
    },
    gtm: {
        id: "GTM-MFC2WLD",
    },
    sentry: {
        dsn: "https://93ed3e0cbdc54aad8409e9a8d6c3b321@o399431.ingest.sentry.io/4504604448129024",
        env: "production",
        sampleRate: 0.2,
        enableLogs: true,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
    },
};
